module.exports = __webpack_public_path__ + "img/tab5.eacba4f0.png";